<template>
  <div>
    <div>
      <img
        class="backImg"
        src="@/assets/images/companyProfile/backgroundImg.jpg"
      />
    </div>
    <div class="container">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="21" :md="16">
          <div class="contentBox">
            <div class="leftBox">
              <div class="menuTitle">
                <span>部门介绍</span>
              </div>
              <div
                :class="activeIndex == index ? 'activemenu' : 'menu'"
                v-for="(item, index) in cardData"
                @click="menuClick(index)"
              >
                <div class="menu-title">{{ item.name }}</div>
                <div class="menu-to">></div>
              </div>
            </div>

            <div class="rightBox">
              <div class="boxTitle">
                {{ cardData[activeIndex].name }}
              </div>
              <div class="content" v-if="cardData[activeIndex].duty !== ''">
                <div class="content title">工作职责</div>
                <div class="remark">
                  {{ cardData[activeIndex].duty }}
                </div>
              </div>

              <div
                class="content"
                v-if="cardData[activeIndex].business_info !== ''"
              >
                <div class="content title">业务信息介绍</div>
                <div class="remark">
                  {{ cardData[activeIndex].business_info }}
                </div>
              </div>

              <div
                class="content"
                v-if="cardData[activeIndex].staff_set.length !== 0"
              >
                <template
                  v-for="(item, index) in cardData[activeIndex].staff_set"
                >
                  <div class="content title">
                    {{ item[0].staff_type_name }}
                  </div>
                  <div class="remark in" v-for="item2 in item">
                    <div>
                      <img
                        class="headPic"
                        src="@/assets/images/companyProfile/24.jpg"
                      />
                    </div>
                    <div class="card">
                      <div class="card-name">{{ item2.name }}</div>
                      <div class="card-tab">
                        <!-- <span>雨纷纷</span>
                      <el-divider direction="vertical"></el-divider>
                      <span>旧故里</span>
                      <el-divider direction="vertical"></el-divider>
                      <span>草木深</span> -->
                        {{ item2.title }}
                      </div>
                      <div class="card-content">
                        <el-card :body-style="{ padding: '10px' }">
                          {{ item2.experience }}
                        </el-card>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { index } from "@/api/departmentIntroduction/departmentIntroduction";
export default {
  data() {
    return {
      activeIndex: 0,
      yearIndex: 0,
      menu: [
        { title: "训练部", showInfo: true, showStar: true },
        { title: "维护部", showInfo: true, showStar: true },
        { title: "信息技术部", showInfo: true, showStar: true },
        { title: "市场销售部", showInfo: true, showStar: false },
        { title: "综合管理部", showInfo: false, showStar: true },
        { title: "企划财务部", showInfo: false, showStar: true },
        { title: "科创管理部", showInfo: false, showStar: true },
        { title: "纪委办公室", showInfo: false, showStar: false },
      ],
      cardData: [],
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      index().then((res) => {
        if (res.code === 0) {
          res.data.forEach((element) => {
            if (element.staff_set.length !== 0) {
              let type = element.staff_set.map((e) => e.staff_type_name);
              type = [...new Set(type)];
              let a = [];
              for (const i of type) {
                let arr = element.staff_set.filter((e) =>
                  i.includes(e.staff_type_name)
                );
                a = [...a, arr];
              }
              element.staff_set = a;
              ;
            }
          });
          ;
          this.cardData = res.data;
        }
      });
    },
    menuClick(index) {
      this.activeIndex = index;
    },
  },
};
</script>

<style scoped>
.backImg {
  width: 100%;
  /* height: 300px; */
}
.container {
  padding: 20px;
}
.contentBox {
  display: flex;
}
.leftBox {
  width: 20%;
  margin-right: 20px;
}
.menuTitle {
  padding: 10px 20px;
  background-color: #32589f;
  text-align: center;
}
.menuTitle > span {
  color: #fff;
}
.activemenu {
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border: 1px solid #dcdfe6;
  border-top: 0px;
  background-color: rgba(245, 245, 245, 1);
  cursor: pointer;
}
.activemenu > div {
  color: #32589f;
  font-weight: 800;
}
.menu {
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border: 1px solid #dcdfe6;
  border-top: 0px;
  cursor: pointer;
}
.menu > div {
  color: #333;
}
.menu-title{
  margin-left: 8px;
}
.rightBox {
  padding: 5px;
  width: 100%;
}
.boxTitle {
  font-size: 22px;
  font-weight: 800;
  padding-bottom: 10px;
  color: #015a9c;
  letter-spacing: 2px;
  border-bottom: 1px solid #dcdfe6;
}
.content {
  font-family: "Arial Normal", "Arial";
  color: #333;
  font-size: 15px;
  margin-top: 30px;
  letter-spacing: 2px;
  text-align: justify;
}
.content .title {
  font-size: 18px;
  font-weight: 800;
  color: #015a9c;
  margin-bottom: 10px;
}
.in {
  display: flex;
  margin-bottom: 20px;
}
.card {
  width: 100%;
  margin-left: 10px;
}
.card-name {
  font-size: 18px;
  font-weight: 800;
  color: #015a9c;
  margin-bottom: 10px;
}
.card-tab {
  margin-bottom: 10px;
}
.headPic {
  width: 150px;
}
@media only screen and (max-width: 768px) {
  .backImg {
    width: 100%;
    height: auto;
  }
  .contentBox {
    display: block;
  }
  .leftBox {
    width: 100%;
    margin-right: 0;
    margin-bottom: 10px;
  }
  .boxTitle {
    font-size: 17px;
  }
  .content {
    margin-top: 20px;
    font-size: 13.5px;
  }
  .content .title {
    font-size: 15px;
  }
  .headPic {
    width: 100px;
  }
}
</style>